import {
  AfterContentInit,
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { HomeCarouselModel } from "../../models/home-carousel.model";
import { Flat } from "../../models/flat.model";
import { Router } from "@angular/router";
import * as _ from "underscore";
import { FlatManagerService } from "../../service/flat-manager.service";
import { TestFlats } from "../../util/test-flats";
import { fromEvent, Subscription } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { UIHelper } from "../../util/ui-helper";
import { Flats } from "../../models/flats.model";

const IMAGE_RATIO = 2.021052631578947;

@Component({
  selector: "app-carousel-wrapper",
  templateUrl: "./carousel-wrapper.component.html",
  styleUrls: ["./carousel-wrapper.component.scss"],
})
export class CarouselWrapperComponent
  implements OnInit, AfterViewInit, AfterContentInit, OnDestroy
{
  @Input() selectorMode: boolean;
  @Input() selectedFlat: Flat;
  @Input() carouselItems: HomeCarouselModel[] = [];
  @Output() positionSelected = new EventEmitter();
  index = 8;
  speed = 2000;
  infinite = true;
  direction = "right";
  activeIndex: number = 0;
  activeSide: string = "FRONT";
  loaded: boolean = false;
  highlightedFlat: Flat;
  flats: Flat[];
  subscriptions: Subscription[] = [];
  ratio: number;
  parentContainer: any;
  imageHeight: number;
  selectedPoint: { x: number; y: number; side: string };
  currentWidth: number = 0;
  currentHeight: number = 0;

  constructor(private router: Router, private flatService: FlatManagerService) {
    this.flatService.flats.subscribe((flats: Flats) => {
      if (flats && flats.items) {
        this.flats = flats.items;
      }
    });

    this.subscriptions.push(
      fromEvent(window, "resize")
        .pipe(debounceTime(100))
        .subscribe(() => {
          this.setImageDimensions();
          this.initMouseMoveListener(2000);
        })
    );
  }

  ngOnInit() {}

  ngAfterContentInit(): void {
    setTimeout(() => {
      this.setImageDimensions();
      this.initMouseMoveListener(2000);
    });

    setTimeout(() => {
      this.loaded = true;
    }, 750);
  }

  setImageDimensions() {
    if (this.selectorMode) {
      this.parentContainer = document.getElementsByTagName(
        "app-flat-frontage-position-selector"
      )[0];
      if (this.parentContainer) {
        this.imageHeight =
          parseInt(window.getComputedStyle(this.parentContainer).width) /
          IMAGE_RATIO;
      }
    } else {
      this.imageHeight = window.innerWidth / IMAGE_RATIO;
    }
  }

  ngAfterViewInit() {}

  getCarouselItemBg(item) {
    return {
      background: `url('${item.imageUrl}') center center no-repeat`,
      "background-size": "cover",
    };
  }

  indexChanged(index) {
    this.activeIndex = index;
    this.activeSide = this.carouselItems[this.activeIndex].side;
    // this.initMouseMoveListener(1000);
  }

  carouselImageLoaded() {
    this.updateCurrentDimensions();
    // this.initMouseMoveListener(1000);
  }

  initMouseMoveListener(timeout) {
    setTimeout(() => {
      let element: HTMLImageElement = document.querySelector(
        ".active-carousel-item"
      );
      this.ratio = element.naturalWidth / element.offsetWidth;

      console.log("element.naturalWidth", element.naturalWidth);
      console.log("element.offsetWidth", element.offsetWidth);
      console.log("this.ratio", this.ratio);

      if (this.selectedFlat && this.selectorMode) {
        this.selectedPoint = {
          x: this.selectedFlat.coordinateX,
          y: this.selectedFlat.coordinateY,
          side: this.selectedFlat.side,
        };
      }

      if (!this.selectorMode) {
        this.subscriptions.push(
          fromEvent(
            document.getElementsByClassName("carousel")[0],
            "mousemove"
          ).subscribe((event) => {
            this.highlightedFlat = null;
            const filteredFlats = this.flats.filter(
              (item) => item.side && item.side === this.activeSide
            );
            _.forEach(filteredFlats, (flat: Flat) => {
              let mouseX = Number(event["x"]);
              let mouseY = Number(event["offsetY"]);

              let flatX = this.convertWithPercentageToPixel(flat.coordinateX);
              let flatY = this.convertHeightPercentageToPixel(flat.coordinateY);

              if (
                mouseX > flatX - 50 &&
                mouseX < flatX + 50 &&
                mouseY > flatY - 50 &&
                mouseY < flatY + 50
              ) {
                this.highlightedFlat = flat;
              }
            });
          })
        );
      }

      this.subscriptions.push(
        fromEvent(
          document.getElementsByClassName("carousel")[0],
          "click"
        ).subscribe((event) => {})
      );
    }, timeout);
  }

  updateCurrentDimensions() {
    let element: HTMLImageElement = document.querySelector(
      ".active-carousel-item"
    );
    this.currentHeight = element.getBoundingClientRect().height;
    this.currentWidth = element.getBoundingClientRect().width;
  }

  convertWithPercentageToPixel(x: number) {
    return this.currentWidth * (x / 100);
  }

  convertHeightPercentageToPixel(y: number) {
    return this.currentHeight * (y / 100);
  }

  carouselClicked(event) {
    if (
      event.target.classList.contains("material-icons") ||
      event.target.classList.contains("direction") ||
      event.target.classList.contains("square")
    ) {
      return;
    }

    if (this.selectorMode) {
      const mouseX = UIHelper.getCoordinates(event, null).x;
      const mouseY = UIHelper.getCoordinates(event, null).y;

      this.updateCurrentDimensions();

      const positionToSend = {
        x: (mouseX / this.currentWidth) * 100,
        y: (mouseY / this.currentHeight) * 100,
        side: this.activeSide,
      };
      this.positionSelected.emit(positionToSend);

      this.selectedPoint = positionToSend;
    } else {
      _.forEach(this.flats, (flat: Flat) => {
        if (
          !flat.side ||
          flat.side !== this.carouselItems[this.activeIndex].side
        ) {
          return;
        }

        let mouseX = Number(event["x"]);
        let mouseY = Number(event["offsetY"]);

        let flatX = this.convertWithPercentageToPixel(flat.coordinateX);
        let flatY = this.convertHeightPercentageToPixel(flat.coordinateY);

        if (
          mouseX > flatX - 50 &&
          mouseX < flatX + 50 &&
          mouseY > flatY - 50 &&
          mouseY < flatY + 50
        ) {
          this.router.navigateByUrl("/flat/" + flat.id);
        }
      });
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  getHightLightedFlat(getX: boolean) {
    let element: HTMLImageElement = document.querySelector(
      ".active-carousel-item"
    );
    if (!element) {
      return 0;
    }

    if (getX) {
      return this.convertWithPercentageToPixel(
        this.highlightedFlat.coordinateX
      );
    } else {
      return (
        this.convertHeightPercentageToPixel(this.highlightedFlat.coordinateY) -
        120
      );
    }
  }

  getHightLightedFlatRectPos(getX: boolean) {
    let element: HTMLImageElement = document.querySelector(
      ".active-carousel-item"
    );
    if (!element || (!this.highlightedFlat && !this.selectedPoint)) {
      return 0;
    }
    const x = this.selectedPoint
      ? this.selectedPoint.x
      : this.highlightedFlat.coordinateX;
    const y = this.selectedPoint
      ? this.selectedPoint.y
      : this.highlightedFlat.coordinateY;

    if (getX) {
      return this.convertWithPercentageToPixel(x) - 25;
    } else {
      return this.convertHeightPercentageToPixel(y) - 25;
    }
  }

  openFlatPage() {
    this.router.navigateByUrl(
      "/flat/" + this.highlightedFlat.project + "/" + this.highlightedFlat.id
    );
  }

  removeHuf(priceString) {
    return priceString.replace("HUF", "");
  }
}
